import { action, makeObservable, observable } from 'mobx'
import { ReactElement } from 'react'

export type RoutingInfoType = 'pickUp' | 'dropOff' | 'generalCargoPickUp' | 'generalCargoDropOff'

export interface RoutingInfoData {
  type: RoutingInfoType
  containerNumber?: string
  blockName?: string
  visitLabel?: string
  generalCargoOrderId?: number
  generalCargoLocation?: string
}
export class GateClerkDocumentsPageViewStore {
  isLoading = false
  isDownloading = false

  routingInfoData: RoutingInfoData[] = []
  miniMap: ReactElement | null = null

  constructor() {
    makeObservable(this, {
      isLoading: observable,
      isDownloading: observable,

      routingInfoData: observable,
      miniMap: observable.ref,

      setLoading: action,
      setRoutingInfoData: action,
      setMiniMap: action,
      reset: action,
    })
  }

  setRoutingInfoData(data: RoutingInfoData[]) {
    this.routingInfoData = data
  }

  setMiniMap(element: ReactElement | null) {
    this.miniMap = element
  }

  setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  reset() {
    this.routingInfoData = []
    this.miniMap = null
  }
}
